import type { DrillLocation } from '../../types/exploration';
import { reasonLabelForVolume } from '../sidebar/focusedReasonHelpers';
import { secondaryBucketKey } from '../secondaryGrouping';
import { volumeStatusLabel } from '../sidebar/volumeStatusLabel';
import type { GroupingModel } from './types';
import {
  volumeAccountKey,
  volumePassedThroughInstance,
  withVolumeStatusOverlay,
} from './groupingPathShared';

export const tagGrouping: GroupingModel = {
  secondary: 'tag',

  locationForVolume(volume, opts) {
    const account = opts.groupByAccount ? volumeAccountKey(volume) : undefined;
    const tagValue = secondaryBucketKey(volume, 'tag', opts.tagKey);
    const structural: DrillLocation['structural'] = volumePassedThroughInstance(
      opts.currentLocation,
      volume
    )
      ? { kind: 'tag', tagValue, instanceId: volume.instanceId! }
      : { kind: 'tag', tagValue };

    return withVolumeStatusOverlay({ account, structural }, volume, opts.view);
  },

  locationForInstance(anchor, instanceId, opts) {
    if (!instanceId) return null;
    const account = opts.groupByAccount ? volumeAccountKey(anchor) : undefined;
    const tagValue = secondaryBucketKey(anchor, 'tag', opts.tagKey);
    return { account, structural: { kind: 'tag', tagValue, instanceId } };
  },

  scopeForLocation(volumes, location, opts) {
    let vols = volumes;
    if (location.account) vols = vols.filter((v) => volumeAccountKey(v) === location.account);

    const s = location.structural;
    if (s.kind === 'tag') {
      if (s.tagValue) {
        vols = vols.filter(
          (v) => ((v.tags && opts.tagKey && v.tags[opts.tagKey]) || '(untagged)') === s.tagValue
        );
      }
      if (s.instanceId) vols = vols.filter((v) => (v.instanceId || '(no instance)') === s.instanceId);
    }

    if (location.statusLabel) {
      vols = vols.filter((v) => volumeStatusLabel(v, opts.view) === location.statusLabel);
    }
    if (location.focusedActivationKey) {
      vols = vols.filter((v) => v.activationStatus === location.focusedActivationKey);
    }
    if (location.reasonLabel) {
      vols = location.focusedActivationKey
        ? vols.filter(
            (v) => reasonLabelForVolume(v, location.focusedActivationKey!) === location.reasonLabel
          )
        : vols.filter((v) => v.supportLabel === location.reasonLabel);
    }

    return vols;
  },
};
